import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Skeleton from "@mui/material/Skeleton";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";

function MissionDensityMap({ points }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <Card
      sx={{
        height: "100%",
        minHeight: "22rem",
        borderRadius: "1.25rem",
        border: "none",
        boxShadow: "0 4px 24px rgba(52, 71, 103, 0.07)",
        overflow: "hidden",
      }}
    >
      <SoftBox px={{ xs: 3, md: 3.5 }} pt={{ xs: 3, md: 3.5 }} pb={2}>
        <SoftTypography variant="h6" fontWeight="bold" mb={1} sx={{ lineHeight: 1.35 }}>
          Mission activity heatmap
        </SoftTypography>
        <SoftTypography variant="caption" color="text" display="block" sx={{ lineHeight: 1.55 }}>
          Relative density of recent missions (dummy coordinates)
        </SoftTypography>
      </SoftBox>
      <SoftBox height="17.5rem" width="100%" position="relative">
        {!ready ? (
          <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: 0 }} />
        ) : (
          <MapContainer
            center={[39.5, -98.35]}
            zoom={4}
            style={{ height: "100%", width: "100%" }}
            scrollWheelZoom={false}
            aria-label="Mission density map"
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {points.map((p) => (
              <CircleMarker
                key={`${p.pos[0]}-${p.pos[1]}`}
                center={p.pos}
                radius={14 + p.intensity * 22}
                pathOptions={{
                  color: "#002054",
                  fillColor: "#17c1e8",
                  fillOpacity: 0.35 + p.intensity * 0.35,
                  weight: 2,
                }}
              >
                <Popup>{p.label}</Popup>
              </CircleMarker>
            ))}
          </MapContainer>
        )}
      </SoftBox>
    </Card>
  );
}

MissionDensityMap.propTypes = {
  points: PropTypes.arrayOf(
    PropTypes.shape({
      pos: PropTypes.arrayOf(PropTypes.number).isRequired,
      intensity: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MissionDensityMap;
